module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "chapter02"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "164",
      "src": "images/f0041-01.jpg",
      "width": "665"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "page_41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Contents#rchapter02"
    }
  }, [_vm._v("Chapter II")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_c('b', [_vm._v("Drought")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a1"
  }, [_c('b', [_vm._v("1976")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "normalc"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("Slit Ear walked up behind Tia with her ears spread slightly. Tia looked back over her shoulder and quickly moved ahead, leaving the small patch of grass where she was feeding. Slit Ear immediately went to the same patch and fed on it for a few minutes. Tia found another clump of dry yellow grass and began to graze again. She twirled her trunk around the short brittle stems and kicked at the base with her front right foot. Dust and grass chaff flew up as a clump was dislodged. Tia beat the clump against her knee, knocking more dirt and dust and dry bits from it. She then placed what remained in her mouth and as she chewed she tackled another small clump with trunk and foot in an unbroken rhythm. Spread out all around her were the other members of her family and Teresia’s family. All the adults and older juveniles fed in the same manner: twirling, kicking, beating, and chewing, and the only sounds were the thuds and slaps of their grazing and the steady flapping of their ears against their necks and shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The 13 elephants fed for another half hour. In that time Slit "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("Ear supplanted Tia twice more and the young female Tess once. There was no protest from them; they just moved on in search of other small patches of grass. They ate with no apparent enthusiasm. All their movements were slow and deliberate in what appeared to be an effort to husband their energy. They were hungry in a dull, lethargic way, but there was little food available and what there was was mostly unpalatable and of little nutritional value. The younger calves, Slit Ear’s and Teresia’s, born in 1971, were still suckling from their mothers, but the milk was no longer as rich as it had been and there was not enough of it to satisfy them. They fed on vegetation as well, but they were not as adept at handling the short dry grass. Slit Ear’s calf got under the chin of her older sister and ate the grass that she loosened or dropped. Teresia’s calf stuck close to his mother. The older calves who had recently been weaned — Right Fang and Trista’s son — were having the hardest time. They were not getting any extra from their mothers and had to fend for themselves. As each day of the dry season progressed they grew weaker and more tired.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When the two families finished grazing, they rested for a while under the shade of some yellow-barked "), _c('i', [_vm._v("Acacia xanthophloea")]), _vm._v(" trees. After another half hour they moved out and crossed an open stretch of bare, dusty ground to a strip of acacias. Here the older animals broke off small branches from the trees and, carefully maneuvering them with foot and trunk, fed on the twigs, bark, and four-inch-long thorns. The adults were experienced at handling this potentially dangerous food, but the younger calves could neither break off the branches nor manipulate the thorns so that they would not pierce their tongues, gums, and insides of their mouths. They stood near their mothers and picked up the smallest twigs and bits of bark.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("After browsing on the acacias for nearly an hour, the elephants walked on west through the strip of trees to an area of the swamp where it runs like a river through steep banks, bordered by "), _c('i', [_vm._v("Cynodon dactylon")]), _vm._v(" grass. However, the grass, usually a major item in the elephants’ diet, was eaten down to bare stubble and the whole area was covered in the dung of the animals that had fed there.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Slit Ear led the two families to a place where the bank was less steep. Each elephant lowered its front legs over the edge, then "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("kneeling on its hind legs, worked its way down the bank and into the water. The water was only a few feet deep and they were able to cross with no trouble. At the opposite bank they used the reverse technique, scrabbling up to the top of the bank, then kneeling on the lip with their front legs and pulling themselves up over the edge. Teresia and her calf were the last to cross. The calf made it down and across the water but had difficulty getting up the opposite bank. When Teresia walked on to join the others, the calf gave a low rumble of distress, and Teresia, Tina, and Tallulah spun around and came back over to the bank with their ears spread forward and trunks out. They reached for him as he struggled over the lip, rumbling to him. When he made it up, he shook his head and let out a long, loud rumble and the females answered with a softer sound, touched him with their trunks, and then they all turned and walked on to the others.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("They were now on an island of hard ground, covered again in eaten-down stubble. Slit Ear did not attempt to graze here but crossed to an area of slower-moving water with thick papyrus and other swamp vegetation. The adults and older juveniles lowered themselves in and began to feed. The younger calves joined them, but the vegetation was coarse and unpalatable. They ate whatever they could find.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("No sooner had they begun to feed when they heard the sound of bells of Maasai cattle and the whistles and shouts of their herders. The elephants lifted their heads, raised their trunks, and immediately turned and began to run out of the swamp. No trumpets or rumbles could be heard, just the grunts of the animals as they struggled out of the mud. They raced across the island, slid down the bank into the water, and hurried through, their momentum carrying them up the other side. They ran, with ears laid flat against their shoulders and tails held up and out, back through the acacia strip, across the open dusty plain, and into an area of mixed acacia and palm trees. They finally slowed their pace when they were about a mile from the swamp. They stopped, formed a defensive circle, flapped their ears, and raised their trunks once more, smelling in the direction from which they had come. It was nearing midday and temperatures were already high and the running had heated their bodies. Trista put her trunk into her mouth "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("and with a gurgling sound pulled her trunk back out and sprayed behind her ears with liquid. The others followed her example, some reaching several times into their mouths, sucking water from their stomachs, and spraying their heads, chests, and necks. They then stood flapping their ears rhythmically, cooling the blood in the surface veins of the ears.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Teresia turned and began walking in a northeasterly direction, letting Slit Ear pass her and take the lead. They arrived at the edge of the woodland where it bordered an open, dusty pan. Here they rested under some trees, but after a short time the sound of cattle bells could be heard to the south and the elephants had to move again. They crossed the pan with Slit Ear in the lead, and Teresia in her usual place in the rear. They did not panic this time because the sounds had been from some distance, but they walked at a fair pace. They passed to the north of one of the tourist lodges, ignoring it completely, and eventually arrived at the northern end of the Longinye swamp, where there was no open water. Here there were many other groups of elephants spread out feeding on dry grass. To the south, where the grass was slightly greener from underground dampness, were several thousand Maasai cattle. The elephants, along with buffaloes, zebras, wildebeests, waterbucks, impalas, and Grant’s and Thomson’s gazelles, were concentrated in a small area where the Maasai did not bring their livestock.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The area still had grass but it was of poor quality. The buffaloes looked like skeletons with old fur rugs thrown over them. There were no young among them at all. The adults had long strings of mucus hanging from their noses, and some had blood-flecked foam on their mouths. The zebras also appeared to be suffering. Many had diarrhea and some were painfully thin, such a rare thing to see in the usually butterball-fat little horses. The wildebeests were also thin and they all seemed lethargic. The gazelles, feeding on small herbs and shrubs, were faring better, but their coats looked rough and dull, indicating a poor diet. The shoulder bones and hipbones of the elephants jutted out and their skin hung loosely in folds and deep wrinkles. Dotted among the living animals were the rotting carcasses and skeletons of those that had succumbed to the drought.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When Slit Ear and Teresia and the others had grazed for a "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("while they started heading south toward the open water, slowly moving and feeding at the same time. They were still several hundred yards away from the water when a mixed herd of wildebeests and zebras were just approaching the drinking area. The wildebeests and zebras moved cautiously, stopping, looking around, stamping their feet, then moving forward several more paces. About 30 yards up from the drinking place, hidden in the swamp vegetation, were two lions, a male and female. To the wildebeests they were gray blobs amongst more or less gray vegetation. To a human being or another primate the heads of the lions were distinctly tawny against the dark-green reeds. The two lions waited patiently with their ears flattened and their bodies hugging the ground. They had already been there for half an hour watching the herd slowly and cautiously approaching.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When the herd of wildebeests and zebras were less than ten yards from the water’s edge they stopped again and remained tense and alert. Suddenly a black-headed heron flew up from the swamp and the herd wheeled and ran back 20 yards. They stood there for another five minutes, stamping and fidgeting, before beginning a new approach. They arrived to within 15 feet of the water and stopped again, but now their thirst took over and the ones in the back began pushing forward, forcing the leaders to move to the water’s edge. The first animals entered the water and began to drink, but still the lions remains crouched and hidden. More animals waded in and spread out around the original drinkers until 20 or 30 wildebeests and zebras were drinking in a tight mass. Then the lions made their move. They sat up, which caused instant pandemonium, hesitated a few seconds, and then made their sprint while the animals were turning and running and jostling each other. The two lions ran into this maelstrom, and the lioness, picking out one young wildebeest, closed in, grabbed it by the head, and tossed it to the ground, quickly getting a hold over its mouth and nose. Before the dust had even settled the male joined her, holding on to the rear quarters. The lioness kept a firm hold on the wildebeest’s mouth, preventing it from breathing. There was barely a struggle, but even weakened by the drought the animal took several minutes to die. In the meantime, coming out of various hiding places along the edge of the swamp were "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("several more lions: another female and two nearly grown cubs. They began to feed before the female relinquished her hold on the wildebeest’s nose. Finally, after nearly ten minutes, she released her grip. She lay panting from her effort and did not begin to feed at once.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("By now Slit Ear and Teresia were about 50 yards away, coming down to the water’s edge for a drink. Lions cannot kill an adult elephant, but they can kill a baby, and in general elephants are intolerant of lions. Teresia in particular was antagonistic toward lions, probably because of an unpleasant experience sometime in her long life. The elephants had seen the running wildebeests and zebras at the edge of their vision but had not yet seen or smelled the lions. When they got closer, the wind shifted slightly and they picked up the lions’ scent. Under certain circumstances the elephants might have just altered their path and drunk at another spot, but their choice of drinking places was limited by the Maasai, and in any case Teresia was not in the habit of letting lions change her plans. She came forward from her usual position at the rear and walked directly and quickly toward the lions, with her head held high and ears spread. The lions were busy feeding, growling and slurping and in general making a considerable amount of noise. Teresia was almost upon them before they noticed her. They took one look and scattered in every direction, and then skulked into the reeds to hide. Teresia swung her trunk at them as they ran away and blew down through her nose. Her family came up behind her. Less self-possessed than she in the face of five lions, they, especially the younger females, were clearly excited. They flapped their ears, gave sharp shakes of their heads, and let out shrill trumpets. They all milled about, rumbling and greeting and reassuring one another with trunk touches. After a few minutes they calmed down and went on to the water’s edge to drink.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Slit Ear and Teresia continued south in search of slightly better vegetation, but always keeping the Maasai and their cattle at a considerable distance. The rains were not expected for several more months and the food was rapidly disappearing. The lion incident was a rare distraction in an otherwise relentless pursuit for food. Teresia was bringing her 50-plus years of experience into play to try to see her family through "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("yet another drought, but some of the places she had gone to when she was younger were closed off now and there were fewer choices in the face of this drought.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The lions returned to their kill and squabbled again amongst themselves for the best pieces, but in a mild sort of way. For the predators there was a superabundance of food, and their next meal was waiting just over the rise.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Droughts are not unusual in Amboseli. The name Amboseli comes from the Maa word "), _c('i', [_vm._v("empusel")]), _vm._v(", which can mean “salty dust,” “open plain,” or “barren place,” depending on one’s source. It is an area of unpredictable climate and changing environment. By its annual rainfall alone Amboseli would be considered a near desert. It receives only an average of 12 to 13 inches of rainfall per year. The area’s rains tend to bypass Amboseli because of a combination of wind and temperature currents created by Kilimanjaro. The mountain, less than 25 miles away, gets most of the rain.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("However, Amboseli is by no means a desert. At the same time that Kilimanjaro prevents rainfall from reaching Amboseli, it provides water by other means. Underground aquifers run from the mountain with fresh, clear, cold water which has percolated down through the porous lava from the very summit. The aquifers run for about 25 miles to bubble up in springs in the Amboseli basin. There the water forms channels, pools, swamps, and marshes, and eventually flows and peters out onto the plains and into Lake Amboseli.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The name "), _c('i', [_vm._v("Lake Amboseli")]), _vm._v(" has probably enticed and then disappointed many a traveler hoping to find a lakeside camping site cooled by fresh-water breezes. The lake is a cracked, bone-dry pan for most of the year and floods only seasonally for short periods during the rains and some years not at all. Present-day Lake Amboseli is the remnant of a much larger Pleistocene lake that occupied an extensive area right up to the lower slopes of the mountain. The area that this former lake once covered, approximately 230 square miles, is commonly referred to as the Amboseli basin. Within the basin lie the 150 square miles that comprise Amboseli National Park.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Geological evidence shows that during the late Tertiary, a large river flowed southeast through the park, carried on down "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("through Tanzania, and emptied into the Indian Ocean at present-day Tanga. In the late Pliocene or early Pleistocene, 2 to 4 million years ago, Kilimanjaro emerged as a result of volcanic activity and its bulk and surrounding lava fields dammed the river, which then had no outlet. Lake Amboseli was formed. During much of the Pleistocene, the river and runoff from the surrounding higher ground deposited sediments in the lake. Volcanic ash was added by periodic eruptions on Kilimanjaro. Eventually the lake filled with sediments and the river was redirected. After several cycles of drying out and flooding, the majority of the lake became desiccated, leaving only a portion to the west that floods periodically. This final desiccation period may have taken place only 5,000 to 10,000 years ago, which is very recent in geological time scales.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The fact that the Amboseli basin was a former closed drainage lake has had, and continues to have, a profound effect on the ecology of the area. For thousands of years salts washed from the soils were carried down the river and deposited in the lake. When the lake dried up these salts were concentrated in the soil. Under these conditions only a few salt-tolerant plant species could grow. Eventually, with rainfall, the salts leached down through the soil in some areas, leaving the surface soil less saline. Other plants could then take hold and even trees began to grow. The salts, however, remained in the water table, several feet below the surface, and would continue to influence the vegetation in years to come.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Amboseli’s complex geological history and its current hydrology and rainfall patterns have resulted in an area with a surprising diversity of habitats and fauna. Within the basin there are open plains, bushed-grassland, bushlands, woodlands, and swamps. A great variety of insects, birds, and mammals are found there. Some of the species live in all the habitats, others in particular ones, still others in only one. The large mammal community is both abundant and diverse. There are elephants, rhinos, hippos, giraffes, buffaloes, zebras, 13 species of antelopes ranging from the tiny dik-dik to the 1,200-pound eland, four kinds of primates, three large cats, wild dogs, two species of hyenas, three species of jackals, several species of smaller cats, plus mongooses, genets, squirrels, hares, and odd species such as the aardwolf, zorilla, ant bear, tree hyrax, honey "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("badger, and porcupine. Over 400 species of birds have been recorded in Amboseli.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Man and his livestock have been an important element in the Amboseli ecosystem for several thousand years. The present inhabitants of the area, the Maasai people, have been there for about 400 years. They apparently displaced another tribe of pastoralists whom the Maasai called the "), _c('i', [_vm._v("Iloogalala")]), _vm._v(" — “people of the hard teeth” — and who were forced south. The Maasai were traditional pastoralists noted for their fierce warriors, who raided far and wide for cattle. These were considered to be rightly theirs because their god, Lengai, had given them all the cattle in the world. Their military prowess was well known and they were feared by other tribes and by ivory traders, slave dealers, missionaries, and explorers. While Europeans had explored areas of the interior as early as 1848, few ventured into Maasailand. In 1883 Joseph Thomson (for whom the Thomson’s gazelle is named) finally traveled extensively in the area, apparently while most of the warriors were away on a long-distance raid.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("On that trip in 1883 Thomson passed through what is now called Amboseli. He found a flat dusty area with no trees but spectacular views of the mountains all around. In his book "), _c('i', [_vm._v("Through Masailand")]), _vm._v(", published in 1887, he noted, “In spite of the desolate and barren aspect of the country, game is seen in marvelous abundance.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In an indirect way the Maasai were responsible for this abundance of animals. They themselves did not hunt wild animals for meat or trophies, and they were intolerant of other tribes hunting in their area. The Maasai warriors sometimes killed large dangerous animals such as lions, elephants, buffaloes, and rhinos to prove their bravery, but this had little impact on population numbers. In times of severe drought or cattle disease, they killed antelopes for meat, but they considered them God’s cattle, to be used only as a last resort. This attitude meant that the Maasai have lived more or less in harmony with wildlife wherever they have roamed. Throughout East Africa the areas noted for wildlife today are those that are held by the Maasai or other pastoralists.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Amboseli was recognized very early on as a special wildlife area when, in 1899, it was included in the Ukamba Game Reserve, "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("created by the British administration. In 1906 the name was changed to the Southern Game Reserve, which covered 10,700 square miles. This area was a reserve mostly only in name, but the Game Department did try to control poaching and to regulate legal hunting in the area. In the 1930s stricter controls were brought into action, and Amboseli became popular with hunters, photographers, and filmmakers because its wildlife had the reputation of being easy both to photograph and to kill.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In 1948 the reserve was reduced to 1,260 square miles, named the Amboseli Game Reserve, and placed under the administration of Kenya’s National Parks Trustees, a parastatal body. In 1961 the same area became a County Council Game Reserve administered by the Kajiado County Council. (To avoid confusion, it should be explained that in Kenya there are two types of protected areas: national parks and reserves. National parks are administered by the central government, while reserves are administered by the local county council with technical advice from the Wildlife Department. Parks are set aside for the exclusive use of wildlife and tourism, while reserves allow limited human activity by local people, such as cattle grazing and timber felling.)")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Under county council administration, revenue from a reserve theoretically goes to the people living in the area in the form of development projects initiated by the council. In 1964, recognizing the value of the Amboseli Reserve in terms of income from tourism, the Kajiado County Council set aside 30 square miles of the central part of the reserve for wildlife and tourist activities only, and the Maasai agreed to keep their cattle out of that area. This situation continued for another seven years, when, under pressure from conservationists, President Jomo Kenyatta (Kenya became independent of Great Britain in December 1963) issued a decree declaring that an area of 150 square miles be set aside exclusively for wildlife and tourism. In 1972 the boundaries were demarcated and the area was gazetted as government land. Finally, in October 1974, Amboseli National Park was established and once again came under the control of the National Parks Trustees. The Kajiado County Council retained an enclave within the park where the tourist lodges were situated and still received revenue from both the park and the lodges.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("The decision to make Amboseli a park was a controversial one, for the basin swamps were an important dry-season refuge for the Maasai and their cattle. The Maasai, who had always shared their whole range with wildlife, were asked to abandon these swamps, restrict their movements, and still allow the wildlife to move onto their remaining land. Coincidentally, as part of a scheme for the whole of Maasailand, the land outside the park was adjudicated and parceled out into large group ranches, more or less along clan lines, each run by a committee of elders. Negotiations were carried out with these new ranch committees and various promises were made, including alternative watering points outside the park, grazing compensation fees for the wildlife that came onto the ranches, plus the provision of a medical dispensary, school, and community center. During the upheaval of negotiations, relationships between the Maasai and the government became tense and one of the results was deliberate spearing of rhinos and elephants as a form of political protest. Eventually an agreement was made, but the Maasai were not asked to leave the park as soon as it was established. A pipeline taking water out to the ridges to the north and east had yet to be completed.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When I started my study in September 1972, the wildlife-human situation was not at its best. Nevertheless, Amboseli seemed an ideal place to study elephants. Despite the spearings, the Amboseli elephants were one of the last populations of relatively undisturbed elephants in East Africa. In almost all other areas, elephants had been compressed into national parks and reserves through human expansion. For example, between 1929 and 1959, Uganda’s human population rose from 3.5 to 5.5 million. In 1929 elephants occupied approximately 70 percent of all the land in that country; in 1959 they occupied only 17 percent, having been forced into the security of a few national parks and forest reserves as human activities expanded into their ranges. In Lake Manyara, where Iain Douglas-Hamilton worked, the elephants had lost 75 percent of their former range in the 50 years preceding the study. At the beginning of his study there were 480 elephants living in approximately 35 Square miles, giving Lake Manyara one of the highest elephant densities ever recorded — nearly 14 elephants per Square mile.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _vm._v("In almost all the areas where elephants have lost range it has been due to the spread of agriculture. Elephants and man cannot coexist where agriculture is practiced because elephants will eat and trample crops. Elephants and pastoralists can coexist far more easily because they are not in acute conflict, although they may be in some competition for the available grazing. Amboseli’s elephants had been lucky in that they shared their range with traditional pastoralists who more or less tolerated them.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In 1972 the elephants were still moving in and out of the central Amboseli basin in the same migratory pattern that they had been using for several hundred years. Although eventually the legal protected area was only 150 square miles, the whole range that the elephants were able to use was about 1,200 square miles. With a population of approximately 600 elephants, that meant a density of only two elephants to the square mile. Even considering the area within the basin where the elephants concentrated, there was only a density of about three elephants per square mile.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Amboseli’s elephants were also fortunate and unusual in 1972 in that they were not being systematically and intensively poached for ivory. The early 1970s was the beginning of a period of severe elephant poaching in most of Kenya. The price of ivory had risen sharply and in the space of only a few years elephant populations were decimated throughout most of the country. In Amboseli there was little or no ivory poaching in the park itself, but when the elephants left on their wet-season migrations they encountered armed poachers. Some of these poachers were Maasai, but most were people from other parts of Kenya and even from other countries. The Maasai were not tolerant of these intruders and often reported them to the Wildlife Department. In this way large-scale poaching in the area was kept in check.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Thus Amboseli’s elephants, being neither heavily poached nor compressed into a small protected area, provided a unique opportunity to study a population that was relatively natural, that is, one that was responding primarily to environmental pressures rather than to predominantly man-made pressures. I hoped that a study of undisturbed elephants would provide base-line data that might eventually help in the conservation of all elephants.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When Harvey and I started the part-time study in 1972, I did "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _vm._v("not realize that within a few years I was going to witness some of the most severe environmental pressures that many of the Amboseli elephants would probably undergo in their lifetimes. Rainfall in the first three years of the study was average to lower than average, but at the same time Maasai cattle had increased considerably, so there was a very high biomass of animals competing for the rapidly diminishing resources. By the end of 1974 conditions were poor. Then followed two years of very low rainfall with almost no vegetation production. The wildlife and the Maasai and their cattle suffered greatly. Many wild animals died and the Maasai lost over half their cattle. It was an extremely stressful time for people and animals alike.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In September 1975, after a period of uncertainty about the future of the project, when Harvey changed jobs and gave up working on the elephants, I finally got a grant from the African Wildlife Foundation and began the more intensive phase of the study on my own. I set up a permanent camp in the park and began to live there the majority of the time. For the first four months I used my own small Renault car; in January 1976 AWF turned over to my project an eight-year-old Land-Rover, which made getting around a great deal easier.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Living in the park right among the elephants changed the study considerably. I was now able to gather information on their daily movements, association patterns, and behavior. Some families I saw several times in a week and I began to know them well. Torn Ear’s, Tania’s, Slit Ear’s, and Teresia’s were among those families. I began to do special studies on some of the groups, trying to find out if there was a clear-cut dominance rank among the females within a family.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I would find one of the families I was concentrating on and spend several hours with it, either watching one individual for a given amount of time or observing the whole group and noting particular behavior. The TCs and TDs were two of the family units I had chosen. It did not take many hours with Slit Ear to discover that she was a very dominant animal who did not hesitate to push subordinates around. Teresia was also of high dominance status, in fact she was dominant to Slit Ear, but she rarely supplanted other individuals. Simply put, some elephants seemed to be more aggressive than others. All the same I became very fond of both Slit Ear and Teresia, Slit Ear because she had "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _vm._v("such a regal demeanor and Teresia because she was old and dignified and gentle and seemed very, very wise.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The other animals in the TC and TD families also became well known as the months went by. Tia kept very much in the shadow of Slit Ear, and young Tess was often the object of Slit Ear’s aggression. In Teresia’s family Trista was a quiet, reserved female, Tina a slender, unobtrusive young female, while Tallulah and Teresia’s younger daughter, whom I named Theodora, were at times flamboyant and playful.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Tallulah and Theodora showed this lighter side of their nature only a few times in 1975 and 1976. For the most part they had to concentrate on finding enough food as the drought became more and more acute. In November 1975 the normal “short rains” were expected, and clouds built up and rolled in from the east, tantalizing both man and animals, but when the rains came they were disappointing. In December I gave up hoping for more, and realized that the animals would have a hard time getting through January, February, and March before the “long rains” were due.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Finally, in April 1976, the long rains came, but they proved to be inadequate, just enough to bring up the barest flush of green. With no further moisture the growth soon stopped. In the midst of the drought, several calves were born to members of the T families. On April 7 Tia was found with a tiny newborn baby, another male, making her the mother of two sons; in May Slit Ear had a calf, another daughter; in June the young female, Tuskless, Torn Ear’s daughter, gave birth to her first calf, a female; and in July Trista gave birth to a female.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Other females in the population gave birth as well, and in this year of severe drought, it appeared to be very difficult for the mothers to keep these calves alive. In many cases the mothers altered their normal behavior in what seemed to be an attempt to save their calves. From February to August 1976, I recorded 26 females with new calves. It surprised me to find many of these females separated from their families, just moving with their new calf and perhaps an older calf or a young female from the family. As family units are speculated to have evolved primarily for their antipredator benefits, particularly for young calves, it seemed strange that the mothers would leave their families when their calves were so vulnerable.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _vm._v("I soon realized that one of the reasons the females were separating was that they were restricted as to which habitats they could move in with their new babies. One day I watched the FA family come to the Enkongo Narok swamp in the morning. On this day the female Fiona was recorded with a new calf. The rest of the family plunged into the reeds and waded out into water over six feet deep. Fiona stayed close to the shore with her new baby and fed on the sparse vegetation there. Eventually her family moved to the other side of the swamp and got out on the opposite shore. Fiona was left on the other side with just her new calf. I saw the two of them on their own for several days after that.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Over half of the females who gave birth in 1976 separated from their families for periods ranging from a day to several months. Most of the mothers who split were young females living in families that contained older females who were dominant to them. Under the particularly harsh conditions that prevailed, they may have broken away in order to avoid competition with the bigger females.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Nevertheless, leaving the family appeared to be a last-ditch effort on the part of the mothers to save their calves. In the end nearly half of the 1976 calves died. Every day I found mothers with thin, lethargic little calves moving along the edges of the swamp. A few days later I would find the mother back with her family but with no calf. I never found any carcasses of dead calves. I suppose the predators and scavengers devoured them quickly, or they died in the swamps, where their bodies disappeared in the water and mud.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Of the first-year calves that died in 1976 about half died when they were less than two months old, and the rest died when they were about five or six months old. The newborn calves probably died because their mothers did not have adequate milk supplies. The calves may also have been of low birth weight to start with if their mothers were undernourished during pregnancy. The stronger ones were able to survive for several months, but when they would normally begin feeding on vegetation to supplement their milk diet, at between three and four months old, there was almost nothing for them to eat.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I was saddened but not surprised to find the first-year calves dying. What did surprise me was the disappearances of four-to "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _vm._v("five-year-old calves. Calves this age were found completely separated from their families feeding in the swamps by themselves. I speculated that they were weakened because they had recently been weaned (elephants give birth to calves about every four to five years and a calf suckles until the next calf is born). It appeared that they were no longer able to keep up with their families in the normal daily movement patterns.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I will always remember one bleak day in August 1976 when I found one of my favorite elephants, Amy, with her three calves: her male calf born at the end of March, her daughter, Audrey, who was then four years old, and her son Albert, who was about nine years old. Amy stood with her head hung low, resting while her calves ate bits of old yellow grass around the base of a "), _c('i', [_vm._v("Suaeda")]), _vm._v(" bush. Audrey walked over to Amy and rubbed her head against her rear leg. Amy turned, rumbled, and mildly threatened Audrey, who moved away. Then the baby started to approach Amy, and as he tried to pass Audrey, she kicked backward at him in a halfhearted way. He walked around her and began to suckle from Amy. Audrey moved closer and slowly reached backward with her hind leg and gently touched Amy repeatedly. She must have been very hungry. Audrey had been suckling up till the baby was born in March, but was now refused.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In September I found Amy’s family, the AA family, near my camp in a highly agitated state. They ran away when I tried to drive near them. The matriarch, Wart Ear, had a fresh spear wound through her ear. The young female, Alison, was streaming with temporal gland secretions and her baby, born the month before, was gone. Amy was missing. I was very upset. I had become caught up in the lives of Amboseli’s elephants, especially the well-known ones such as the AAs and the Ts. When I saw Wart Ear with a fresh spear wound my stomach began to churn and knot and my palms began to sweat. I knew then that I was no longer a truly objective observer. I sat there in the Land-Rover telling myself that I must be scientific and impartial but my stomach told me that I hated seeing Wart Ear wounded and I very much did not want Amy to be dead.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Unfortunately, there seemed no end in sight to the drought and the deaths. Conditions were very severe and no rains could be expected until November. I began finding elephant carcasses "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _vm._v("and getting similar reports from the warden. Each time I located a group of elephants I carried out a census with trepidation, hoping I would not find anyone missing. Cattle were dying by the hundreds, and as a result Maasai tempers were short and they were spearing elephants and rhinos, not for their tusks or horns but apparently simply in frustration. I was angry with the Maasai for spearing elephants but I also sympathized with them. It was pitiful to see the herds of gaunt, bony cattle moving each day through the park in search of grass. I dreaded driving out each morning because I knew I would see the dead and dying cows everywhere. When a Maasai cow became too weak to follow the herd it lay down and refused to get up again. It usually took about two days to die. It would lie there looking peaceful, chewing the cud (made up of what I do not know). The gullies on the sides of the roads seemed to be the most common place for cattle to die. Each evening there were new ones lying alongside the roads as I drove back to camp. I knew there was nothing I could do for them and I just had to drive by. In the morning some would be dead and some would still be lying there waiting to die.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I did not see the AA group again for 20 days after the day I found Wart Ear wounded, and when I did find them Amy was there but she had a spear wound in her side, and her baby was gone. Amy’s breasts were shriveled and shrunken and she looked thin and ill. She stood touching the wound with her trunk and from time to time spraying dust on it.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("On the next few sightings both Wart Ear and Amy seemed to be recovering, but at the end of October I found the AAs, and after repeated counts trying to make eleven and getting only ten, I saw that Audrey was missing. I thought she must have been speared by the Maasai. Four days later I saw the family again and there was Audrey! She was with her family for several more days and then on November 20 she was gone again. Later that week I found a four-to five-year-old calf completely on its own feeding in the Enkongo Narok swamp. When I went closer I saw that it was Audrey.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I had seen lone calves of her age before staying near the swamps. I did not recognize any of them individually and thus did not know what eventually happened to them but I assumed that they were sick, lost, or abandoned and that they died. I "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _vm._v("thought it was the beginning of the end for Audrey. Presumably she was weakened by the loss of milk in her diet, combined with the bad conditions. Instead of following her family out to the woodlands at night, she refused or was unable to leave the swamp edge, and stayed there feeding and conserving her strength. I saw her with her family one more time, and then in the swamp again on her own. Then I saw the family several more times without her. I thought that she had died by then.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Finally in December some good rains fell and the drought ended. On January 5, 1977, I found the AAs and was very surprised and happy to see Audrey following right behind Amy like a normal mother-oriented calf. She has stayed with her family ever since. To me, it was an amazing feat of survival. Lions could easily kill a calf her size, and it would seem that natural selection would wipe out calves that tried to use this “loner” strategy. Subsequent evidence has shown that most calves who leave their families die, but somehow Audrey beat the odds.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The drought took a mighty toll on the elephant population. In 1976 a minimum of 48 elephants in the family groups died, and at least 30 independent males died as well. Of the cows and calves, 17 were adult females who were either speared or shot, 14 were first-year calves, and the rest were older calves. Thus I knew of 78 elephants that had died, but as I did not know the whole population in 1976, I estimated that several more animals, who had not yet been photographed and registered, had also died.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The T families got through the drought with no deaths at all, which was unusual. Even the four young babies survived. The Ts lived in the central part of the park, where heavy tourist traffic may have inhibited Maasai spearings; and they spent their daytime hours in the Ol Tukai Orok woodlands and the Longinye swamp, which were probably the best habitats available. In addition the families contained one old and very experienced female (Teresia) and two large mature females (Slit Ear and Torn Ear), one of whom (Slit Ear) did not hesitate to use aggression in order to get enough to eat for herself and her calves. More than anything I would guess that it was Teresia’s knowledge which carried them through the drought.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("By the end of 1976 I knew the Ts very well and had named most of the remaining youngsters. In general I now named all "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _vm._v("individuals who were weaned. Unweaned calves were referred to by their mother and their year of birth — for example, Torn Ear’s C (for “calf’) ’74, or Slit Ear’s C’76. I named Torn Ear’s older calves Tilly and Teddy, Tania’s eight-year-old son Taabu, which means “trouble” in Swahili, Slit Ear’s two older daughters Tamar and Tara, Teresia’s son Tolstoy, and Trista’s son Tim. Tania’s older son, who became fully independent sometime in 1976, was given the male code M84 and taken off the family list. The four T families contained the following 26 animals (the numbers in parenthesis next to a name are the estimated or known year of birth for that elephant and the symbols indicate sex):")]), _vm._v(" "), _c('div', {
    staticClass: "move1"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TA")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Torn Ear (33)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("C’74")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or1.jpg",
      "width": "10"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Tilly (70)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Teddy (66)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or1.jpg",
      "width": "10"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Tuskless (62)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("    C’76")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Tonie (67)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TB")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Tania (44)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("C’73")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or1.jpg",
      "width": "10"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Taabu (69)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or1.jpg",
      "width": "10"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TC")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Slit Ear (36)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("C’76")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Tamar (71)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Tara (67)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Tess (63)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Tia (50)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("C’76")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or1.jpg",
      "width": "10"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Right Fang (70)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or1.jpg",
      "width": "10"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TD")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Teresia (22)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Tolstoy (71)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or1.jpg",
      "width": "10"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Theodora (67)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Tina (62)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Trista (38)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("C’76")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Tim (69)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or1.jpg",
      "width": "10"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Tallulah (63)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/or.jpg",
      "width": "8"
    }
  })])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ad487c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter02.vue
// module id = 87
// module chunks = 0